export default "__VITE_ASSET__LmG0z_4Q__"